export function rafThrottle<T extends (...args: any[]) => any>(fn: T): T & { clear: () => void } {
  // eslint-disable-next-line custom-rules/no-let
  let lastArgs: Parameters<T>;
  // eslint-disable-next-line custom-rules/no-let
  let rafRef: ReturnType<typeof requestAnimationFrame> | null;

  const later = () => {
    rafRef = null;
    fn(...lastArgs);
  };

  function throttled(...args: Parameters<T>) {
    lastArgs = args;
    if (!rafRef) {
      rafRef = requestAnimationFrame(later);
    }
  }

  throttled.clear = () => {
    if (rafRef) {
      cancelAnimationFrame(rafRef);
      rafRef = null;
    }
  };

  return throttled as T & { clear: () => void };
}
